var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.326 6.174a1.875 1.875 0 00-2.652 0l-10.5 10.5a1.875 1.875 0 000 2.652l10.5 10.5a1.875 1.875 0 102.652-2.652L16.152 18l9.174-9.174a1.875 1.875 0 000-2.652z",
    fill: "#818181"
  })));
}

export default SvgAngleLeft;